import { Auth0Client } from '@auth0/auth0-spa-js';

export default new Auth0Client({
	domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
	client_id: process.env.REACT_APP_AUTH0_CLIENTID || '',
	audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
	cacheLocation: 'localstorage',
});
